// extracted by css-extract-rspack-plugin
export default {"Table":"Oi1mB"};